<div class="content">
    <sub-header [title]="ld('Support')" [breadcrumbs]="breadcrumbs" [backlink]="backlink">
    </sub-header>

    <div [class]="containerClass + ' ' + additionalContainerClass" *ngIf="ticket">
        <div class="mz-card mz-card-insets mb-8">
            <div class="form-group">
                <label for="title">{{ l("Title") }}</label>
                <div class="d-flex flex-row px-4">
                    <i *ngIf="ticket.resolved" class="me-4 pi pi-check-circle mz-green"
                        style="line-height: inherit"></i>
                    <i *ngIf="!ticket.resolved" class="me-4 pi pi-question-circle mz-orange"
                        style="line-height: inherit"></i>
                    <p id="title">{{ticket.title}}</p>
                </div>
            </div>
            <div class="form-group">
                <label for="date">{{ l("CreationDate") }}</label>
                <p id="type" class="px-4">{{datePipe.transform(ticket.creationTime.toJSDate(), "dd.MM.YYYY HH:mm")}}</p>
            </div>
            <div class="form-group">
                <label for="type">{{ l("Type") }}</label>
                <p id="type" class="px-4">{{typeToName(ticket.type)}}</p>
            </div>
            <div class="form-group">
                <label for="module">{{ l("Module") }}</label>
                <p id="module" class="px-4">{{this.ld(ticket.module) ?? l("None")}}</p>
            </div>
            <div class="form-group">
                <label for="description">{{ l("Description") }}</label>
                <p id="title" class="px-4" style="white-space: pre-wrap">{{ticket.description}}</p>
            </div>

            <div class="form-group">
                <label for="lastPath">{{ld('Support_LastPath')}}</label>
                <p id="lastPath" class="px-4">{{ticket.lastPath}}</p>
            </div>

            <div class="form-group">
                <label for="lastPath">{{ld('DeletedByUser')}}</label>
                <p id="lastPath" class="px-4">{{toYesNo(ticket.deletedByUser)}}</p>
            </div>

            <div class="form-group">
                <label for="files">{{ld('FileUpload')}}</label>

                <p *ngIf="ticket.attachments.length == 0" class="px-4">{{l("None")}}</p>
                <div *ngIf="ticket.attachments.length > 0" class="mx-4 p-1 d-flex flex-column gap-1 align-items-stretch"
                    style="background-color: var(--mazars3)">
                    @for(attachment of ticket.attachments; track $index) {
                    <div class="m-1 p-4" style="background-color: white">
                        <span class="alert-text">
                            {{ attachment.name }}
                        </span>
                        <button type="button" class="btn p-0 vertical-align-top">
                            <span (click)="download(attachment)">
                                <i aria-hidden="true" class="mx-2 pi pi-download"></i>
                            </span>
                        </button>
                        <br>
                    </div>
                    }
                </div>
            </div>

            <div class="d-flex flex-row-reverse gap-2">
                <app-mazars-button [label]="l('Resolve')" [busy]="busy" [disabled]="ticket.resolved"
                    iconClass="pi pi-check-circle" (onClick)="resolve()"></app-mazars-button>

                <app-mazars-button [label]="l('Reopen')" [busy]="busy" [disabled]="!ticket.resolved"
                    iconClass="pi pi-question-circle" (onClick)="reopen()"></app-mazars-button>
            </div>
        </div>

        <div class="mz-card mz-card-insets mb-8">
            <h5>{{l("User")}}</h5>
            <div class="form-group">
                <label for="user-name">{{ l("Tenant") }}</label>
                <p class="px-4">{{ticket.tenantName}}</p>
            </div>
            <div class="form-group">
                <label for="user-name">{{ l("Name") }}</label>
                <div class="px-4">
                    {{ticket.user.fullName}} ({{ticket.user.userName}})
                </div>
            </div>
            <div class="form-group">
                <label for="user-email">{{ l("EmailAddress") }}</label>
                <p id="user-email" class="px-4"><a
                        [href]="'mailto:' + ticket.user.emailAddress">{{ticket.user.emailAddress}}</a></p>
            </div>
            <div class="form-group">
                <label for="user-phone">{{ l("PhoneNumber") }}</label>
                <p id="user-phone" class="px-4">
                    <a *ngIf="ticket.user.phoneNumber"
                        [href]="'tel:' + ticket.user.phoneNumber">{{ticket.user.phoneNumber}}</a>
                    <span *ngIf="!ticket.user.phoneNumber">{{l("None")}}</span>
                </p>
            </div>
        </div>

        <div class="mz-card mz-card-insets">
            <support-messages [tenantId]="ticket.tenantId" [ticket]="ticket" [isUser]="false"
                [token]="accessToken"></support-messages>
        </div>
    </div>
</div>